<template>
  <div>
    <!-- Skeleton for the header/top info -->
    <div class="col-md-12 mt-5">
      <div class="row">
        <div class="col-md-6 p-10">
          <div class="box-monitoring-mother">
            <div class="row">
              <div class="col box-monitoring divider">
                <v-skeleton-loader type="text" height="30" width="100" />
                <v-skeleton-loader type="text" height="20" width="80" />
              </div>
              <div class="col box-monitoring divider">
                <v-skeleton-loader type="text" height="30" width="100" />
                <v-skeleton-loader type="text" height="20" width="80" />
              </div>
              <div class="col box-monitoring">
                <v-skeleton-loader type="text" height="20" width="120" />
                <v-skeleton-loader type="text" height="20" width="120" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 p-10">
          <div class="box-monitoring-mother">
            <div class="row">
              <div class="col-md-3 box-monitoring divider">
                <v-skeleton-loader type="text" height="20" width="60" />
                <v-skeleton-loader type="text" height="20" width="40" />
              </div>
              <div class="col-md-3 box-monitoring divider">
                <v-skeleton-loader type="text" height="20" width="60" />
                <v-skeleton-loader type="text" height="20" width="40" />
              </div>
              <div class="col-md-6 justify-content-center align-items-center d-flex flex-column">
                <v-skeleton-loader type="text" height="20" width="200" />
                <v-skeleton-loader type="text" height="20" width="200" />
                <v-skeleton-loader type="text" height="20" width="200" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Skeleton for remitos list -->
    <div class="col-md-12">
      <div class="row">
        <div class="col p-10 pr-3 ">
          <div v-for="i in 3" :key="i" class="mb-2">
            <v-skeleton-loader type="card" height="80" />
          </div>
        </div>
        <div class="col p-10 pl-3 ">
          <v-skeleton-loader type="image" height="300" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RutasDetallesSkeleton",
};
</script>
